import {
  PrimitiveFn,
  PrimitiveOptions,
  typeahead,
} from "@mirage/service-typeahead-search/service/types";

function primitiveFactory<T extends typeahead.ResultType>(
  type: T,
): PrimitiveFn<T> {
  return (
    uuid: string,
    result: typeahead.TypeToPrimitive<T>,
    options?: PrimitiveOptions,
  ): typeahead.$Tagged<T> => {
    return {
      type,
      uuid,
      result,
      sectionId: options?.sectionId,
      hits: options?.hits,
    };
  };
}

export const searchResult = primitiveFactory<typeahead.ResultType.SearchResult>(
  typeahead.ResultType.SearchResult,
);
export const previousQuery =
  primitiveFactory<typeahead.ResultType.PreviousQuery>(
    typeahead.ResultType.PreviousQuery,
  );
export const suggestedQuery =
  primitiveFactory<typeahead.ResultType.SuggestedQuery>(
    typeahead.ResultType.SuggestedQuery,
  );
export const stack = primitiveFactory<typeahead.ResultType.Stack>(
  typeahead.ResultType.Stack,
);
export const stackItem = primitiveFactory<typeahead.ResultType.StackItem>(
  typeahead.ResultType.StackItem,
);
export const urlShortcut = primitiveFactory<typeahead.ResultType.URLShortcut>(
  typeahead.ResultType.URLShortcut,
);
export const recommendation =
  primitiveFactory<typeahead.ResultType.Recommendation>(
    typeahead.ResultType.Recommendation,
  );
export const mathCalculation =
  primitiveFactory<typeahead.ResultType.MathCalculation>(
    typeahead.ResultType.MathCalculation,
  );
export const searchFilter = primitiveFactory<typeahead.ResultType.SearchFilter>(
  typeahead.ResultType.SearchFilter,
);
export const desktopFile = primitiveFactory<typeahead.ResultType.DesktopFile>(
  typeahead.ResultType.DesktopFile,
);
export const desktopApplication =
  primitiveFactory<typeahead.ResultType.DesktopApplication>(
    typeahead.ResultType.DesktopApplication,
  );
export const askSuggestion =
  primitiveFactory<typeahead.ResultType.AskSuggestion>(
    typeahead.ResultType.AskSuggestion,
  );
export const askUserQuery = primitiveFactory<typeahead.ResultType.AskUserQuery>(
  typeahead.ResultType.AskUserQuery,
);
export const recentChat = primitiveFactory<typeahead.ResultType.RecentChat>(
  typeahead.ResultType.RecentChat,
);
export const draftWithSource =
  primitiveFactory<typeahead.ResultType.DraftWithSource>(
    typeahead.ResultType.DraftWithSource,
  );
export const draftFromTemplate =
  primitiveFactory<typeahead.ResultType.DraftFromTemplate>(
    typeahead.ResultType.DraftFromTemplate,
  );
export const draftFromTone =
  primitiveFactory<typeahead.ResultType.DraftFromTone>(
    typeahead.ResultType.DraftFromTone,
  );
export const organizeUserQuery =
  primitiveFactory<typeahead.ResultType.OrganizeUserQuery>(
    typeahead.ResultType.OrganizeUserQuery,
  );
export const writeUserQuery =
  primitiveFactory<typeahead.ResultType.WriteUserQuery>(
    typeahead.ResultType.WriteUserQuery,
  );
export const peopleFilter = primitiveFactory<typeahead.ResultType.PeopleFilter>(
  typeahead.ResultType.PeopleFilter,
);
export const peopleRecommendation =
  primitiveFactory<typeahead.ResultType.PeopleRecommendation>(
    typeahead.ResultType.PeopleRecommendation,
  );
export const myProfileSuggestion =
  primitiveFactory<typeahead.ResultType.MyProfileSuggestion>(
    typeahead.ResultType.MyProfileSuggestion,
  );
export const calendarEvent =
  primitiveFactory<typeahead.ResultType.CalendarEvent>(
    typeahead.ResultType.CalendarEvent,
  );
export const skeleton = primitiveFactory<typeahead.ResultType.Skeleton>(
  typeahead.ResultType.Skeleton,
);
